import type { ChangeEvent } from 'react'

export type ArchiveSortValue = 'newest' | 'price-low' | 'price-high'

type ArchiveSortSelectProps = {
  value: ArchiveSortValue
  onChange: (value: ArchiveSortValue) => void
}

export function ArchiveSortSelect({ value, onChange }: ArchiveSortSelectProps) {
  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    onChange(event.target.value as ArchiveSortValue)
  }

  return (
    <select
      value={value}
      onChange={handleChange}
      className="h-10 rounded-md border border-gray-200 bg-white px-3 text-sm font-medium text-gray-700 shadow-sm"
      aria-label="Sort listings"
    >
      <option value="newest">Newest</option>
      <option value="price-low">Price: low to high</option>
      <option value="price-high">Price: high to low</option>
    </select>
  )
}
